import React, { useState, useEffect } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { flattenToAppURL } from '@plone/volto/helpers';
import { Image } from 'semantic-ui-react';
import "./theme/_main.scss";
import { ConditionalLink } from '@plone/volto/components';

const SliderView = ({ data, isEditMode = false }) => {
  const [activateSlider, setActivateSlider] = useState(false);

  useEffect(() => {
    setActivateSlider(data.slides?.length > 1);
  }, [data]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: data.autoplayEnabled,
    autoplaySpeed: 10000,
    accessibility: true,
    adaptiveHeight: true,
  };
  const leftDesignElem = (
    <div className='leftDesign'>
      <svg width="62.044" xmlns="http://www.w3.org/2000/svg" height="150" fill="none">
        <path d="M0 147h43.148C58.5 148 55.5 135.739 55.5 142L55 19M0 147" className="fills" />
        <g className="strokes">
          <path d="M0 147h43.148C58.5 148 55.5 135.739 55.5 142L55 19M0 147" style={{ fill: 'none', strokeWidth: 5, stroke: 'rgb(255, 255, 255)', strokeOpacity: 1, strokeDasharray: '0, 10', strokeLinecap: 'round' }} className="stroke-shape" />
        </g>
        <path d="M54.522 0c4.151 0 7.522 3.52 7.522 7.855 0 4.335-3.371 7.855-7.522 7.855C50.37 15.71 47 12.19 47 7.855 47 3.52 50.37 0 54.522 0Zm0 3.142c-2.491 0-4.513 2.112-4.513 4.713s2.022 4.713 4.513 4.713 4.513-2.112 4.513-4.713-2.022-4.713-4.513-4.713Z" style={{ fill: 'rgb(255, 255, 255)', fillOpacity: 1 }} className="fills" />
        <g className="strokes">
          <path d="M54.522 0c4.151 0 7.522 3.52 7.522 7.855 0 4.335-3.371 7.855-7.522 7.855C50.37 15.71 47 12.19 47 7.855 47 3.52 50.37 0 54.522 0Zm0 3.142c-2.491 0-4.513 2.112-4.513 4.713s2.022 4.713 4.513 4.713 4.513-2.112 4.513-4.713-2.022-4.713-4.513-4.713Z" style={{ fill: 'none', strokeWidth: 1, stroke: 'rgb(255, 255, 255)', strokeOpacity: 1 }} className="stroke-shape" />
        </g>
      </svg>
    </div>
  );

  const rightDesignElem = (
    <div className='rightDesign'>
      <svg width="314.071" xmlns="http://www.w3.org/2000/svg" height="15" fill="none">
        <path d="M21.5 7.432h292.571" className="fills" />
        <g className="strokes">
          <path d="M21.5 7.432h292.571" style={{ fill: 'none', strokeWidth: 5, stroke: 'rgb(255, 255, 255)', strokeOpacity: 1, strokeDasharray: '0, 10', strokeLinecap: 'round' }} className="stroke-shape" />
        </g>
        <path d="M7.5 0C11.639 0 15 3.361 15 7.5c0 4.139-3.361 7.5-7.5 7.5A7.504 7.504 0 0 1 0 7.5C0 3.361 3.361 0 7.5 0Zm0 3A4.502 4.502 0 0 0 3 7.5C3 9.984 5.016 12 7.5 12S12 9.984 12 7.5 9.984 3 7.5 3Z" style={{ fill: 'rgb(255, 255, 255)', fillOpacity: 1 }} className="fills" />
        <g className="strokes">
          <path d="M7.5 0C11.639 0 15 3.361 15 7.5c0 4.139-3.361 7.5-7.5 7.5A7.504 7.504 0 0 1 0 7.5C0 3.361 3.361 0 7.5 0Zm0 3A4.502 4.502 0 0 0 3 7.5C3 9.984 5.016 12 7.5 12S12 9.984 12 7.5 9.984 3 7.5 3Z" style={{ fill: 'none', strokeWidth: 1, stroke: 'rgb(255, 255, 255)', strokeOpacity: 1 }} className="stroke-shape" />
        </g>
      </svg>
    </div>
  )


  const renderSlide = (slide, index) => (
    <div key={index} role="group" aria-roledescription="slide" aria-label={`Slide ${index + 1} of ${data.slides.length}`}>
      {slide.image && (
        <div className={slide.full ? "image-wrapper" : "mock-image"}>
          <div className={slide.full ? "" : "q container layout"}>
            <Image
              src={flattenToAppURL(`${slide.image['@id']}/@@images/image`)}
              alt={slide.alt || `Slide ${index + 1}`}
            />
          </div>
        </div>
      )}

      <div className="full-width slider-wrapper">
        <div className="slider-box-container">
          <div className="slider-box" role="region" aria-labelledby={`slide-title-${index}`}>
            <div className="q container layout">
              <div className={`headline ${!slide.title2 ? "more" : ""} offset`}>
                {slide.title2 && <h4>{slide.title2}</h4>}
                <h1 id={`slide-title-${index}`}>{slide.title}</h1>
              </div>
              <h3>{slide.description}</h3>
              {slide.button && (
                <div className="pretty">
                  <ConditionalLink to={flattenToAppURL(slide.button_link)} condition={!isEditMode}>
                    <button aria-label={`Mehr erfahren: ${slide.button_text}`}>{slide.button_text}</button>
                  </ConditionalLink>
                </div>
              )}
            </div>
            {index === 0 && rightDesignElem}
            {index === 1 && leftDesignElem}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="block slider full-width" role="region" aria-label="Startseite Slider">
      {activateSlider ? (
        <Slider {...settings}>
          {data.slides?.map(renderSlide)}
        </Slider>
      ) : (
        data.slides?.map(renderSlide)
      )}
    </div>
  );
};

export default SliderView;
